import React from 'react';
import SystemsHeader from '../../components/SystemsHeader';
import SystemsFooter from '../../components/SystemsFooter';
import SeoHead from '../../components/SeoHead';
import LeadForm from '../../components/systems/LeadForm';
import { Mail, MapPin, Clock } from 'lucide-react';

export default function SystemsContact() {
  return (
    <div className="min-h-screen bg-white">
      <SeoHead path="/systems/contact" title="Contact Sales — ZHELTA Systems" description="Speak with a ZHELTA Systems specialist about your enterprise IT needs." />
      <SystemsHeader />
      <main className="py-20 md:py-24">
        <div className="zh-container max-w-5xl grid grid-cols-1 lg:grid-cols-[340px_minmax(0,1fr)] gap-10">
          <div>
            <span className="inline-block text-[11px] font-extrabold uppercase tracking-[0.2em] text-[#c9a227]">Contact Sales</span>
            <h1 className="mt-4 text-4xl sm:text-5xl font-extrabold tracking-tight text-gray-900 leading-[1.05]">Let&apos;s talk.</h1>
            <p className="mt-5 text-[16px] text-gray-600 leading-relaxed">
              Share a bit about your IT needs and our team will respond within 1 business day with a tailored recommendation.
            </p>
            <div className="mt-8 space-y-4 text-[14px] text-gray-700">
              <InfoRow icon={Mail} label="Email" value={<a className="text-[#c9a227] hover:text-[#f5a623]" href="mailto:sales@zhelta.com" data-testid="systems-contact-email-link">sales@zhelta.com</a>} />
              <InfoRow icon={Clock} label="Response time" value="Under 15 min average" />
              <InfoRow icon={MapPin} label="Coverage" value="Worldwide — remote-first" />
            </div>
          </div>
          <div>
            <LeadForm
              kind="contact"
              fields={['company', 'phone', 'message']}
              ctaLabel="Send to sales"
              successTitle="Message sent"
              testIdPrefix="contact-sales"
            />
          </div>
        </div>
      </main>
      <SystemsFooter />
    </div>
  );
}

function InfoRow({ icon: Icon, label, value }) {
  return (
    <div className="flex items-start gap-3">
      <div className="w-9 h-9 rounded-lg bg-amber-50 flex items-center justify-center flex-shrink-0">
        <Icon className="w-4 h-4 text-[#c9a227]" strokeWidth={2} />
      </div>
      <div>
        <div className="text-[11px] font-extrabold uppercase tracking-[0.18em] text-gray-400">{label}</div>
        <div className="text-[14px] font-semibold text-gray-800 mt-0.5">{value}</div>
      </div>
    </div>
  );
}
